import script from "./ChatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatCard.vue?vue&type=script&setup=true&lang=js"

import "./ChatCard.vue?vue&type=style&index=0&id=3db6dab3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db6dab3"]])

export default __exports__